import { render } from "./wjsContent.vue?vue&type=template&id=81e59b36&scoped=true"
import script from "./wjsContent.vue?vue&type=script&lang=js"
export * from "./wjsContent.vue?vue&type=script&lang=js"

import "./wjsContent.vue?vue&type=style&index=0&id=81e59b36&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e59b36"]])

export default __exports__